import React from "react";
import { COMPONENT_TYPES } from "@/helpers/constants";
import VideoComponent from "@/components/PageAllResources/components/Video";
import ArticleComponent from "@/components/PageAllResources/components/Articles";

interface ComponentMappingProps {
  data: any;
  extras?: { [key: string]: any };
}

const ComponentMapping = (props: ComponentMappingProps): React.ReactElement => {
  const { data, extras = {} } = props;
  const { userAgent, categorySlug } = extras;
  const type = data.ComponentType;

  switch (type) {
    case COMPONENT_TYPES.ResourceArticles:
      return <ArticleComponent data={data} userAgent={userAgent} categorySlug={categorySlug} />;
    case COMPONENT_TYPES.ResourceVideos:
      return <VideoComponent data={data} userAgent={userAgent} categorySlug={categorySlug} />;
    default:
      return undefined;
  }
};

export default ComponentMapping;
